import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=0a7df1a2&scoped=true"
import script from "./Emojis.vue?vue&type=script&lang=js"
export * from "./Emojis.vue?vue&type=script&lang=js"
import style0 from "./Emojis.vue?vue&type=style&index=0&id=0a7df1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7df1a2",
  null
  
)

export default component.exports